/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/6/24
 * Time: 16:09
 * Desc: 添加网点弹窗
 */

import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import IPSDialog from '../picker/dialog';
import DialogFactory from '../picker/dialogFactory';
import { IPSService } from '@/services/ipsServices';
import { globalElement } from '@/library/utils/globalElement';

@DialogFactory
@Component
export default class AddPrimarySite extends IPSDialog {
  width = '800px';
  /* 属性 */

  /**
   * 小程序id
   * @type {number}
   */
  sgId = '';
  inSiteCodes: string[] = [];
  outSiteCodes: string[] = [];
  confirm = false;

  public loadingState = false;

  public siteList: Array<AreaSiteShopList> = [];

  code: number;
  /**
   * 页码
   * @type {number}
   */
  public page = 1;

  /**
   * 条数
   * @type {number}
   */
  public pageSize = 20;

  /**
   * 总条数
   * @type {number}
   */
  public totalCount = 0;

  // 是否是秒杀组或者秒杀
  public isSeckill = false;
  /**
   * 关键字
   * @type {string}
   */
  public keywords = '';

  public selected: AreaSiteShopList;

  /**
   * 获取所有网点列表/小程序可用网点
   * @return null
   */
  public getSiteList(): void {
    // 有InSiteCode是查看网点，没有是选择网点
    this.loadingState = true;
    const postParams = {
      inSiteCodes: this.inSiteCodes,
      page: this.page,
      outSiteCodes: this.outSiteCodes,
      pageNum: this.pageSize,
      keywords: this.keywords,
    };
    IPSService.areaSiteList({ postParams }).then(
      (response) => {
        this.totalCount = response.count;
        this.siteList = response.list;
        this.loadingState = false;
      },
      () => {
        this.loadingState = false;
      },
    );
  }

  public getSite() {
    this.loadingState = true;
    const postParams = { keywords: this.keywords, sgId: this.sgId, page: this.page, pageNum: this.pageSize };
    postParams['siteCodes'] = this.code ? this.inSiteCodes : [];
    // IPSService.getAdminAuthTree({ postParams }).then((res) => {
    //   this.loadingState = false;
    //   this.siteList = res.list;
      
    //   this.totalCount = res.count;
    // }),
    IPSService.adminSiteAuthList({ postParams }).then((res) => {
      this.loadingState = false;
      this.siteList = res.siteCodes;
      
      this.totalCount = res.siteCodes.length;
    }),
    () => {
      this.loadingState = false;
    };
  }

  /**
   * 关键字搜索
   * @return null
   */
  public onSearchSite(e?): void {
    if (e && e.keyCode !== 13) {
      return;
    }
    this.page = 1;
    this.pageSize = 20;
    this.isSeckill ? this.getSite() : this.getSiteList();
  }

  mounted() {
    this.isSeckill ? this.getSite() : this.getSiteList();
  }

  /**
   * 条数变更
   * @param {number} val
   * @return null
   */
  public onSizeChange(val: number): void {
    this.page = 1;
    this.pageSize = val;
    this.isSeckill ? this.getSite() : this.getSiteList();
  }

  /**
   * 页码变更
   * @param {number} val
   * @return null
   */
  public onPageChange(val: number): void {
    this.page = val;
    this.isSeckill ? this.getSite() : this.getSiteList();
  }

  /**
   * 选中
   * @param {number | string} siteCode
   * @returen null
   */
  public onSelect(site): void {
    this.selected = site;
    this.$emit('result', this.selected);
    this.$emit('hidden');
  }

  renderContent(h) {
    return (
      <div class="r-px-20">
        <div class="flex-inline items-center border-bottom-white hei-28 width-100 line-height-56 r-pl-10 border-box">
          <div class="wid-195 flex-inline items-center hei-16 relative-position fl">
            <el-input
              v-model={this.keywords}
              placeholder="网点编号/网点名称"
              nativeOn-keyup={(e) => {
                this.onSearchSite(e);
              }}></el-input>
            <i class="wid-15 hei-15 line-height-30 font-size-18 text-grey-15 absolute right-0 cursor-pointer iconfont iconsousuo" onClick={() => this.onSearchSite()}></i>
          </div>
        </div>
        <el-table v-loading={this.loadingState} height="350" style="width: 100%" data={this.siteList} ref="multipleTable">
          <el-table-column type="index" label="ID" width="80" align="left" show-overflow-tooltip></el-table-column>
          <el-table-column prop="siteCode" label="网点编号" width="120px" align="left" show-overflow-tooltip></el-table-column>
          <el-table-column prop="siteName" label="网点名称" min-width="160px" align="left" show-overflow-tooltip></el-table-column>
          {this.isSeckill ? ( <el-table-column prop="siteTel" label="网点电话" width="140px" align="left" show-overflow-tooltip></el-table-column>) : ('')}
          {this.isSeckill ? ( <el-table-column prop="siteAddress" label="网点地址" min-width="160px" align="left" show-overflow-tooltip></el-table-column>) : ('')}
          {!this.code ? (
            <el-table-column
              label="操作"
              align="center"
              {...{
                scopedSlots: {
                  default: (scope) => {
                    return (
                      <span class="scopeSpan" onClick={() => this.onSelect(scope.row)}>
                        选中网点
                      </span>
                    );
                  },
                },
              }}
            />
          ) : (
            ''
          )}
        </el-table>
        <div class="hei-21 r-mt-10 r-py-0 r-pr-18 r-pl-16 border-bottom-white">
          <div class="fr ">
            <el-pagination
              on-size-change={this.onSizeChange}
              on-current-change={this.onPageChange}
              current-page={this.page}
              page-sizes={[10, 15, 20, 30]}
              page-size={this.pageSize}
              layout="total, sizes, prev, pager, next, jumper"
              total={this.totalCount}></el-pagination>
          </div>
        </div>
      </div>
    );
  }
}
